import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Cookies from 'js-cookie';
import { Spinner, Modal, ModalHeader, ModalBody, ModalFooter, Label } from 'reactstrap';
import Translate, { t } from '../../common/Translate';
import { Auth, recordActions } from '../../../config/configuration/react';

export const TradeModal = () => {
  const { recordId } = useParams();
  const dispatch = useDispatch();
  const userId = Auth.userId();
  const roleId = Auth.roleId();
  const recordStatus = useSelector((state) => state.reduxRecords.data[recordId])?.record?.statusId;
  const expressSale = useSelector((state) => state.reduxRecords.data[recordId]?.trade?.sale?.is_express_sale);
  const vehicle = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle;
  const popupMarketingTradeToogle = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.popupMarketingTradeToogle,
  );
  const registrationDate = moment(vehicle?.registrationDate?.date, 'YYYY-MM-DD');
  const vehicleIsOld = registrationDate.isBefore(moment().subtract(10, 'years'));
  const [displayTradePopup, setDisplayTradePopup] = useState(false);
  const [displaySaleConfirmPopup, setDisplaySaleConfirmPopup] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState('');
  const [dontShowPopupAgain, setDontShowPopupAgain] = useState(false);
  const cookieKey = `dontShowTradePopup_${userId}`;

  const toggleCheckbox = () => {
    setDontShowPopupAgain(!dontShowPopupAgain);
  };

  const toggleTradePopup = () => {
    if (dontShowPopupAgain) {
      Cookies.set(cookieKey, true, { expires: 365 });
    }
    setDisplayTradePopup(!displayTradePopup);
  };

  const toggleSaleConfirmPopup = () => setDisplaySaleConfirmPopup(!displaySaleConfirmPopup);

  const postExpressSaleToTrade = async () => {
    if (dontShowPopupAgain) {
      Cookies.set(cookieKey, true, { expires: 365 });
      setDisplayTradePopup(!displayTradePopup);
    } else {
      try {
        setisLoading(true);
        const response = await dispatch(recordActions.postOffer(recordId));
        await setDisplayTradePopup(false);
        if (response?.id) {
          await dispatch(
            recordActions.postAnnonceAt({ sale_offer_type: '/api/sale_offer_types/1', express_sale: true, vehicleId: response.id }),
          );
          await setDisplaySaleConfirmPopup(true);
        } else {
          setApiErrorMessage(response.message);
        }
      } catch (e) {
        setApiErrorMessage(e.message);
      } finally {
        setisLoading(false);
      }
    }
  };

  useEffect(() => {
    const dontShowTradePopup = Cookies.get(cookieKey);
    if (
      !expressSale &&
      !dontShowTradePopup &&
      popupMarketingTradeToogle &&
      recordStatus === 4 &&
      (roleId === 2 || roleId === 4) &&
      (vehicle?.mileage > 100000 || vehicleIsOld)
    ) {
      setDisplayTradePopup(true);
    }
  }, [expressSale, popupMarketingTradeToogle, recordStatus]);

  return (
    <>
      <Modal isOpen={displayTradePopup} toggle={toggleTradePopup}>
        <ModalHeader className="popup-header" toggle={toggleTradePopup}>
          <h6 className="font-weight-bold">{t('pricingTradePopupTitle')}</h6>
          <p className="font-weight-normal h6">{t('pricingTradePopup1')}</p>
        </ModalHeader>
        <ModalBody className="popup-content">
          <p className="font-weight-bold">{t('pricingTradePopup2')}</p>
          <ul>
            <li className="font-weight-normal">{t('pricingTradePopup3')}</li>
            <li className="font-weight-normal">{t('pricingTradePopup4')}</li>
            <li className="font-weight-normal">{t('pricingTradePopup5')}</li>
          </ul>
          {apiErrorMessage && <p className="text-danger">{apiErrorMessage}</p>}
          <div className="d-flex">
            <input
              id="dontShowTradePopupAgain"
              name="dontShowTradePopupAgain"
              type="checkbox"
              className="align-middle mr-2"
              onChange={toggleCheckbox}
              checked={dontShowPopupAgain}
            />
            <Label className="font-weight-bold" for="dontShowTradePopupAgain">
              <Translate code="checkboxPricingTradePopUp" />
            </Label>
          </div>
        </ModalBody>
        <ModalFooter className="popup-ctas">
          <div className="model-footer">
            <button className="btn btn-3 mr-2" type="button" onClick={toggleTradePopup}>
              {t('close')}
            </button>
            <button className="btn btn-1" type="button" onClick={postExpressSaleToTrade}>
              {isLoading && <Spinner size="sm" />}
              {t('sendTradePopup')}
            </button>
          </div>
        </ModalFooter>
      </Modal>

      <Modal isOpen={displaySaleConfirmPopup} toggle={toggleSaleConfirmPopup}>
        <ModalHeader>
          <h5 className="font-weight-bold">{t('validationPopupTrade1')}</h5>
        </ModalHeader>
        <ModalBody>
          <p className="font-weight-normal">{t('validationPopupTrade2')}</p>
          <p className="font-weight-normal">{t('validationPopupTrade3')}</p>
        </ModalBody>
        <ModalFooter className="popup-ctas">
          <div className="model-footer">
            <button className="btn btn-3" type="button" onClick={toggleSaleConfirmPopup}>
              {t('close')}
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};
